import React from 'react';

const Sidebar = ({ setActivePage }) => {
  const menuItems = [
    { name: 'Groups', key: 'groups' },
    { name: 'Level', key: 'subgroups' }, 
    { name: 'User Roles', key: 'roles' },
    { name: 'Training Materials', key: 'training' },
  ];

  return (
    <div className="w-64 h-full bg-gray-800 text-white p-4 space-y-4">
      <h2 className="text-2xl font-bold mb-6">Admin Panel</h2>
      {menuItems.map((item) => (
        <button
          key={item.key}
          className="block w-full text-left px-4 py-2 hover:bg-gray-700 rounded"
          onClick={() => setActivePage(item.key)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

export default Sidebar;
